<template>
  <div class="my-date-picker" @click.stop>
    <div class="title">选择日期或范围</div>
    <div class="dValueBox">
      <input class="dValue" type="text" v-model="bdate" @change="bdateChange" @focus="bdateFocus">
      <span class="separate">--</span>
      <input class="dValue" type="text" v-model="edate" @change="edateChange" @focus="edateFocus">
    </div>
    <div class="yearBox">
      <img class="icLeft" src="@/assets/img/home/ic-left.png" @click="lastMonth()">
      <span class="yearV">{{ calendarData.onYear + '年' + calendarData.onMonth + '月' }}</span>
      <img class="icRight" src="@/assets/img/home/ic-right.png" @click="nextMonth()">
    </div>

    <div class="box-calendar">
      <div class="b-c-week">
        <div
          class="b-c-w-td"
          v-for="item of calendarData.weekList"
          :key="item.id"
        >{{ item.lable }}</div>
      </div>
      <div class="b-c-dateBox">
        <div
          class="b-c-tr"
          v-for="(rowList, rIndex) of calendarData.dateList"
          :key="rIndex"
        >
          <div
            class="b-c-td"
            v-for="(item, index) of rowList"
            :key="index"
          >
            <div
              class="b-c-dayBox"
              :class="{ 'on': item.isNow }"
              v-show="item.offsetMonth == 0"
              @click="setOnDay(item)"
            >
              <div class="dayBox-day">{{ item.day }}</div>
              <div
                v-if="fIsWhichDay(item.date) == 1"
                class="dayBox-lunar b-start"
              >起</div>
              <div
                v-if="fIsWhichDay(item.date) == 2"
                class="dayBox-lunar b-end"
              >止</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { formatDate2 } from "@/utils/common/formatDate.js";
export default {
  props: {
    value: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  data () {
    return {
      bdate: '',
      edate: '',
      selectIndex: 0,
      selectBdate: undefined,
      calendarData: {
        weekList: [
          { id: 0, name: '星期天', lable: '日' },
          { id: 1, name: '星期一', lable: '一' },
          { id: 2, name: '星期二', lable: '二' },
          { id: 3, name: '星期三', lable: '三' },
          { id: 4, name: '星期四', lable: '四' },
          { id: 5, name: '星期五', lable: '五' },
          { id: 6, name: '星期六', lable: '六' },
        ],
        onYear: 2022,
        onMonth: 4,
        dateList: [
        ],
      },
    };
  },
  watch: {
    value: {
      handler(newv, oldv) {
        this.modelValueChange(newv)
      },
      deep: true,
      immediate: true,
    },
    selectIndex: {
      handler(newv, oldv) {
        // 选择完日期后，清空上次保留的日期
        if (newv == 0) {
          this.selectBdate = undefined
        }
      },
    }
  },
  computed: {
  },
  created () {
    if (this.value[0] && Object.prototype.toString.call(this.value[0]) == '[object Date]') {
      this.calendarData.onMonth = this.value[0].getMonth() + 1
      this.calendarData.onYear = this.value[0].getFullYear()
    } else if (this.value[1] && Object.prototype.toString.call(this.value[1]) == '[object Date]') {
      this.calendarData.onMonth = this.value[1].getMonth() + 1
      this.calendarData.onYear = this.value[1].getFullYear()
    } else {
      this.calendarData.onMonth = new Date().getMonth() + 1
      this.calendarData.onYear = new Date().getFullYear()
    }
    this.setShowDateList()
  },
  methods: {
    //选择日期
    setOnDay (item) {
      console.log(item, this.selectIndex)
      let bdate = this.value[0], edate = this.value[1]
      switch (this.selectIndex) {
        case 0:
          this.selectIndex = 1
          this.selectBdate = item.date
          break;
        case 1:
          this.selectIndex = 0
          this.setDateValue([this.selectBdate, item.date]);
          break;
        case 2:
          this.selectIndex = 0
          if (item.date > edate) {
            edate = undefined
          }
          this.setDateValue([item.date, edate]);
          break;
        case 3:
          this.selectIndex = 0
          if (item.date < bdate) {
            bdate = undefined
          }
          this.setDateValue([bdate, item.date]);
          break;
        default:
          this.selectIndex = 0
          break;
      }
    },
    bdateFocus () {
      this.selectIndex = 2
    },
    edateFocus () {
      this.selectIndex = 3
    },
    fIsWhichDay(iDate) {
      try {
        if (this.selectIndex != 1) {
          if (
            this.value[0]
            && iDate.getFullYear() == this.value[0].getFullYear()
            && iDate.getMonth() == this.value[0].getMonth()
            && iDate.getDate() == this.value[0].getDate()
          ) {
            return 1
          }
          if (this.value[1]
            && iDate.getFullYear() == this.value[1].getFullYear()
            && iDate.getMonth() == this.value[1].getMonth()
            && iDate.getDate() == this.value[1].getDate()
          ) {
            return 2
          }
        } else {
          if (
            this.selectBdate
            && iDate.getFullYear() == this.selectBdate.getFullYear()
            && iDate.getMonth() == this.selectBdate.getMonth()
            && iDate.getDate() == this.selectBdate.getDate()
          ) {
            return 1
          }
        }
      } catch (e) {
        console.log(e)
      }
      return 0
    },
    //===========================
    //日期转换
    //===========================
    bdateChange () {
      const revert = ()=>{
        if (this.value[0]) {
          this.bdate = formatDate2(this.value[0], 'yyyy-MM-dd')
        } else {
          this.bdate = ''
        }
      }

      if (this.bdate == '') {
        this.setDateValue([undefined, this.value[1]]);
        return
      }

      if (!/^[0-9]{1,4}[-/][0-9]{1,2}[-/][0-9]{1,2}$/.test(this.bdate)) {
        revert()
        return
      }

      let bdateObj = new Date(this.bdate)
      if (bdateObj == 'Invalid Date') {
        revert()
        return
      }
      
      if (this.value[1] && bdateObj > this.value[1]) {
        revert()
        return
      }

      this.setDateValue([bdateObj, this.value[1]]);
    },
    edateChange () {
      const revert = ()=>{
        if (this.value[1]) {
          this.edate = formatDate2(this.value[1], 'yyyy-MM-dd')
        } else {
          this.edate = ''
        }
      }

      if (this.edate == '') {
        this.setDateValue([this.value[0], undefined]);
        return
      }

      if (!/^[0-9]{1,4}[-/][0-9]{1,2}[-/][0-9]{1,2}$/.test(this.edate)) {
        revert()
        return
      }

      let edateObj = new Date(this.edate)
      if (edateObj == 'Invalid Date') {
        revert()
        return
      }
      
      if (this.value[0] && edateObj < this.value[0]) {
        revert()
        return
      }

      this.setDateValue([this.value[0], edateObj]);
    },
    modelValueChange (newv) {
      console.log(newv)
      let bdateObj = this.value[0],
          edateObj = this.value[1];
      
      if (this.value[0] && Object.prototype.toString.call(this.value[0]) != '[object Date]') {
        bdateObj = undefined
      }

      if (this.value[1] && Object.prototype.toString.call(this.value[1]) != '[object Date]') {
        edateObj = undefined
      }

      if (bdateObj && edateObj && bdateObj > edateObj) {
        let i = bdateObj
        bdateObj = edateObj
        edateObj = i
      }

      if (this.value[0] != bdateObj || this.value[1] != edateObj) {
        this.setDateValue([bdateObj, edateObj]);
      }

      if (bdateObj) {
        this.bdate = formatDate2(bdateObj, 'yyyy-MM-dd')
      } else {
        this.bdate = ''
      }

      if (edateObj) {
        this.edate = formatDate2(edateObj, 'yyyy-MM-dd')
      } else {
        this.edate = ''
      }
    },
    //===========================
    //日历生成
    //===========================
    lastMonth () {
      if (this.calendarData.onMonth - 1 < 1) {
        this.calendarData.onMonth = 12
        this.calendarData.onYear -= 1
      } else {
        this.calendarData.onMonth -= 1
      }
      this.setShowDateList()
    },
    nextMonth () {
      if (this.calendarData.onMonth + 1 > 12) {
        this.calendarData.onMonth = 1
        this.calendarData.onYear += 1
      } else {
        this.calendarData.onMonth += 1
      }
      this.setShowDateList()
    },
    setOnDate (onYear, onMonth) {
      this.calendarData.onYear = onYear
      this.calendarData.onMonth = onMonth
      this.setShowDateList()
    },
    //更新日历显示
    setShowDateList () {
      let onMonth = this.calendarData.onMonth - 1,
        onYear = this.calendarData.onYear,
        nowDate = new Date(),
        onDate = new Date()
      onDate.setDate(1) // 设置成第一天，避免出现某个月天数不足，导致日期错乱
      onDate.setMonth(onMonth)
      onDate.setFullYear(onYear)

      //本月最后一天
      let endDate = new Date(onDate)
      endDate.setMonth(onMonth + 1)
      endDate.setDate(0)
      let maxDay = endDate.getDate() //获取本月天数
      let endWeekDay = endDate.getDay() //最后一天周几

      //本月第一天
      let startDate = new Date(onDate)
      startDate.setDate(1)
      let startWeekDay = startDate.getDay() //第一天周几

      // //获取上个月天数
      // let oldMData = new Date(startDate)
      // oldMData.setDate(0)
      // let oldMaxDay = oldMData.getDate() //上个月天数

      //获取一共需要显示的日历格子数量
      let showDay = maxDay + 6 - endWeekDay
      let DateArr = [],
        lsArr = []
      for (let i = 1 - startWeekDay, weed = 0; i <= showDay;) {
        let itemDate = new Date(startDate)
        itemDate.setDate(i)
        lsArr.push({
          year: itemDate.getFullYear(),
          month: itemDate.getMonth() + 1,
          day: itemDate.getDate(),
          weed: weed,
          offsetMonth: i < 1 ? -1 : i > maxDay ? 1 : 0, //-1为上个月，0为当前，1为下个月
          date: itemDate,
          isNow: nowDate.getFullYear() == itemDate.getFullYear() && nowDate.getMonth() == itemDate.getMonth() && nowDate.getDate() == itemDate.getDate(),
          clockObj: null,
        })
        i++
        weed++
        if (weed > 6) {
          DateArr.push(lsArr)
          lsArr = []
          weed = 0
        }
      }
      this.calendarData.dateList = DateArr
      // console.log(this.calendarData.dateList)
    },
    setDateValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },
};
</script>

<style lang='less' scoped>
.my-date-picker {
  min-width: 238px;
  border-radius: 5px;
  background: #FFFFFF;
  box-shadow: 0 0 7px 0 rgba(0,0,0,.20);
  .title {
    height: 50px;
    text-align: center;
    color: #555555;
    border-radius: 10px 10px 0 0;
    background-color: #F4F7FF;
    font-size: 14px;
    line-height: 50px;
  }
  .dValueBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 42px;
    padding: 0 10px;
    .dValue {
      width: 100px;
      height: 30px;
      padding: 0;
      text-align: center;
      color: #333333;
      border: none;
      border-radius: 4px;
      background: #F0F0F080;
      font-size: 14px;
    }
    .separate {
      text-align: center;
      color: #222222;
      font-size: 14px;
    }
  }
  .yearBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 30px;
    padding: 0 6px;
    .icLeft {
      width: 4px;
      height: 7px;
      padding: 7px 8px;
    }
    .yearV {
      text-align: center;
      color: #999999;
      font-size: 14px;
    }
    .icRight {
      width: 4px;
      height: 7px;
      padding: 7px 8px;
    }
  }

  .box-calendar {
    background: #F6F6F6;
    .b-c-week {
      display: flex;
      height: 30px;
      border-top: 1px solid #F3F3F3;
      border-bottom: 1px solid #DFDFDF;
      background: #FFFFFF;
      font-size: 12px;
      .b-c-w-td {
        box-sizing: border-box;
        width: 14.3%;
        text-align: center;
        line-height: 30px;
      }
      .b-c-w-td + .b-c-w-td {
        border-left: 1px solid #DEE6E6;
      }
    }
    .b-c-dateBox {
      display: flex;
      flex-direction: column;
    }
    .b-c-tr {
      display: flex;
      flex-grow: 1;
    }
    .b-c-tr + .b-c-tr {
      border-top: 1px solid #DEE6E6;
    }
    .b-c-td {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 14.3%;
      height: 30px;
      color: #000000;
    }
    .b-c-td + .b-c-td {
      border-left: 1px solid #DEE6E6;
    }
    .b-c-dayBox {
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column-reverse;
      flex-grow: 1;
      justify-content: center;
      height: 100%;
      text-align: center;
      color: #333333;
      &.on {
        // background-color: #b3dce750;
        color: #409EFF;
      }
      &:hover {
        background-color: #5ED3F250;
      }
      .dayBox-day {
        font-size: 14px;
      }
      .dayBox-lunar {
        position: absolute;
        top: 50%;
        left: 50%;
        display: inline-block;
        width: 24px;
        height: 24px;
        transform: translate(-50%, -50%);
        color: #FFFFFF;
        border-radius: 50%;
        background: #3170FF;
        font-size: 14px;
        line-height: 24px;
      }
      .b-start {
        background: #3170FF;
      }
      .b-end {
        background: #159BE0;
      }
    }
  }
}




</style>